import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";

export default function DeleteAlertModal({ open, setOpen, handleDelete }) {
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "30vw",
    bgcolor: "background.paper",
    boxShadow: 24,
    borderRadius: "13px",
    p: 4,
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography>{"از حذف این آیتم مطمئن هستید؟!"}</Typography>
        <Box gap="10px" display="flex" mt="30px" justifyContent={"end"}>
          <Button sx={{ width: "100px" }} onClick={() => setOpen(false)}>
            {"خیر"}
          </Button>
          <Button
            sx={{
              bgcolor: "var(--emr-red)",
              color: "white",
              width: "100px",
              ":hover": { bgcolor: "#d11632" },
            }}
            onClick={handleDelete}
          >
            {"بله"}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
